import { useQuery } from 'react-query';

import userAvatar from '../assets/images/userAvatar.png';

const axios = require('axios');
// const _ = require('lodash');
// fetch agents

async function fetchAgentSearch() {

  const { data } = await axios.get(
    `https://pd-api.keywaygroup.com/kwg-call-reporting-connector/agents?token=7ec0cdc7dca0670088c8c9fbdb0b3fc92f840d3df70d67c5af95aac81262cb6501d1035831af0d095a959adf4670d205`
  );
  const agents = data.map((agent) => ({
    userImage: userAvatar,
    name: agent.name,
    id: agent.agent_internal_id,
    extensions: agent.extensions,
    position: agent.sub_category,
    workShift: agent.day_shift,
  }));
  return { agents };
}
export const useFetchAgentSearch = (id) => {
  return useQuery(['agents'], () => fetchAgentSearch(), {
    refetchOnWindowFocus: true,
    staleTime: 1 * 60 * 1000,
  });
};
